import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  {
    field: 'title',
    weight: 5, // ElasticSearch boost
  },
  {
    field: 'country_searchable',
    weight: 3,
  },
  {
    field: 'diagnosis_searchable',
    weight: 3,
  },
];

export const resultAttributes = [
  'url',
  'title',
  'nid',
  'field_domain_access',
  'ocular_image',
  'country',
  'country_searchable',
  'diagnosis',
  'diagnosis_searchable',
  'ocular_image',
  'ocular_image_width',
  'ocular_image_height',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'diagnosis',
    field: 'diagnosis',
    type: 'string',
  },
  {
    attribute: 'country',
    field: 'country',
    type: 'string',
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: '_score',
    order: 'desc',
  },
};
